import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function WebAuthnIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 25 25">
      <path
        transform="translate(-5 -5)"
        d="M13 10a5 5 0 0 1 3.934 8.086l7.49 7.49-.141.141a1 1 0 0 1-1.32.083l-.094-.083-6.783-6.783A5 5 0 1 1 13 10zm9.176 11.824l.141-.141a1 1 0 0 1 1.32-.083l.094.083 1.586 1.586a1 1 0 0 1 .083 1.32l-.083.094-.141.141-3-3 .141-.141-.141.141zM13 11.2a3.8 3.8 0 1 0 0 7.6 3.8 3.8 0 0 0 0-7.6z"
      />
    </SvgIcon>
  )
}
